import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from 'reselect';
import { SERVICE_TYPE } from '../../constants';
import { getFTTBExtraServices } from './servicesSelectors';
import { getFTTB } from './commonSelectors';

const withOnlyFirewall = ({ serviceType }) => serviceType === SERVICE_TYPE.firewall;
export const getFTTBFirewallService = (state) => getFTTBExtraServices(state).find(withOnlyFirewall) || emptyObj;
export const getFTTBFirewallLevelItems = (state) => getFTTBFirewallService(state).firewallLevelItems || emptyArr;
export const getFTTBFirewallLevel = (state) => getFTTBFirewallService(state).firewallLevel;
export const getFTTBFirewallNewLevel = (state) => getFTTBFirewallService(state).newFirewallLevel;
export const getFTTBIsFirewallFormVisible = (state) => !!getFTTB(state).isFirewallFormVisible;

export const getIsFirewallLoading = createSelector(
  getFTTBFirewallService,
  getFTTBIsFirewallFormVisible,
  ({ isLoading, futureRequestId }, isFormVisible) => isLoading || futureRequestId || !!isFormVisible,
);
